import { Component, OnInit } from '@angular/core';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-access-revoked',
    templateUrl: './access-revoked.component.html',
    styleUrls: ['./access-revoked.component.scss'],
    standalone: false
})
export class AccessRevokedComponent implements OnInit {
    constructor(private log: LoggingService) {
        this.log.verbose('AccessRevokedComponent: constructor');
    }

    ngOnInit(): void {}
}
